// OGeet Moments — polaroid scatter photos
// To add new photos: append entries below. Each entry gets a rotation
// between -9 and 9 degrees for that scattered / scrapbook feel.

export const OGEET_MOMENTS = [
  {
    url: 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/a1i5zvny_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_11%20AM.png',
    caption: 'Smoking Lamb Shank',
    tilt: -6,
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/t1wh6k08_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_17%20AM.png',
    caption: 'A whole world on one plate',
    tilt: 5,
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/e8tbg7gl_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_35%20AM.png',
    caption: 'Bold new flavors',
    tilt: 7,
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/4o610nmk_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_40%20AM.png',
    caption: 'Refreshing Goodness',
    tilt: -5,
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_dbf2a048-f611-4e3a-928e-b07f29ce499b/artifacts/goy1a9j2_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_03%20AM.png',
    caption: 'Fresh from the traditional bakery',
    tilt: 6,
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_dbf2a048-f611-4e3a-928e-b07f29ce499b/artifacts/n2esutgy_ChatGPT%20Image%20Jul%201%2C%202026%2C%2011_20_06%20AM.png',
    caption: 'Royal Flavors',
    tilt: -4,
  },
];
